export default "__VITE_PUBLIC_ASSET__b23a55a0__"